import type { Entry } from 'contentful';
import { isEntryOrAsset } from '~/utils/guards/isEntryOrAsset';
export function isEntry<TEntryFields = unknown>(
  value: unknown
): value is Entry<TEntryFields> {
  return isEntryOrAsset(value) && value.sys.type === 'Entry';
}
